<template>
  <div class="indicator">
    <pulse-loader
      size="10px"
      color="#409EFF"
    />
    <div v-if="!!text" class="indicator-text text-info">{{text}}</div>
  </div>


</template>

<script>
  import PulseLoader from 'vue-spinner/src/PulseLoader'

  export default {
    name: "Indicator",
    components: {
      PulseLoader,
    },
    props: {
      text: String,
    }
  }
</script>

<style scoped>

</style>
